import { AfterViewInit, Directive, Input, OnInit } from "@angular/core";
import { FormArray, FormControl, FormGroup, PatternValidator, Validators } from "@angular/forms";
import { Yii } from "../../../../../libraries/interfaces/Yii";
import { IFieldSpecs } from "../../../../../libraries/module/formbuilder/fields/interfaces/field-specs";
import { Required } from "../../../../../libraries/module/formbuilder/forms/utils/validators/required.validator";
import { IWatabiLightSectionDetails } from "../../../../../libraries/interfaces/IWenji";
import { IValidator } from "../../../../../libraries/module/formbuilder/forms/utils/validators/IValidator";
import { Email } from "../../../../../libraries/module/formbuilder/forms/utils/validators/email.validator";
import { INotification } from "../../../../../libraries/interfaces/INotification";

export interface IAddressValue {
    zipCode: string;
    numberStreet: string;
    nameStreet: string[];
    city: string;
    country: string;
}

class Wording {
    public readonly title : string = Yii.t('wui-shared-js', 'Titre');
    public readonly type : string = Yii.t('wui-shared-js', 'Type');
    public readonly name : string = Yii.t('wui-shared-js', "Nom de l'agence");
    public readonly firstName : string = Yii.t('wui-shared-js', 'Prénom');
    public readonly lastName : string = Yii.t('wui-shared-js', 'Nom de famille');
    public readonly agencyName: string = Yii.t('wui-shared-js', "Nom de l'agence");
    public readonly logo: string = Yii.t('wui-shared-js', "Logo");
    public readonly mail : string = Yii.t('wui-shared-js', 'Email');
    public readonly phone : string = Yii.t('wui-shared-js', 'Téléphone');
    public readonly address : string = Yii.t('wui-shared-js', 'Adresse');
    public readonly undefined : string = Yii.t('wui-shared-js', 'Non précisé');
    public readonly zipCode: string = Yii.t('wui-shared-js', "Code postal");
    public readonly nameStreet: string = Yii.t('wui-shared-js', "Nom de rue");
    public readonly complementAdd: string = Yii.t('wui-shared-js', "Complement d'adresse ");
    public readonly city: string = Yii.t('wui-shared-js', "Ville");
    public readonly country: string = Yii.t('wui-shared-js', "Pays");
    public readonly invalidmail: string = Yii.t('wui-shared-js', "Erreur mail invalide");
}

@Directive()
export abstract class GenericComponent implements OnInit, AfterViewInit {
    @Input()
    public form: FormGroup;
    @Input()
    public wording: Wording = new Wording();
    @Input()
    public sectionConfig: IWatabiLightSectionDetails;

    public title: string;
    public description: string;

    public errorNotification: INotification = {active: false, message: ""};

    constructor(
    ) {
    }

    public ngOnInit(): void {
        return ;
    }

    public ngAfterViewInit(): void {
        return ;
    }

    public patchValueIfExist(value: string | number, key: string | string[]): void {
        if (value) {
            this.form.get(key).setValue(value);
        }
        // else {
        //     this.form.get(key).setValue(null);
        // }
    }

    public markFieldAsTouch(form: FormGroup): void {
        Object.keys(form.controls).forEach((field: string) => {
            const control = form.get(field);
            if (control instanceof FormGroup) {
                this.markFieldAsTouch(control);
            }
            if (control instanceof FormControl) {
                control.markAllAsTouched();
            }
        });
    }

    public setAddress(addressValue: IAddressValue): string {
        let address: string = "";
        if (addressValue) {
            address = this.addValueToString(address, addressValue.numberStreet);
            address = this.addValueToString(address, addressValue.nameStreet.join(" "));
            address = this.addValueToString(address, addressValue.zipCode);
            address = this.addValueToString(address, addressValue.city);
            address = this.addValueToString(address, addressValue.country, "");
        }
        return (address);
    }

    public getFieldConfig(formGroup: FormGroup,formControlName: string, required: boolean = false): IFieldSpecs {
        return {
            formGroup,
            formControlName: formControlName,
            className: "watabiLightInput",
            label: this.wording[formControlName],
            validators: this.getValidador(required),
            withAsteriskIfRequired: true,
        };
    }

    public getValidador(required: boolean): IValidator[] {
        const validator: IValidator[] = [];
        if (required) {
            validator.push(new Required());
        }
        return validator;
    }

    public initAdressForm(array: string[], formControlName: string, config: any): void {
        if (array) {
            const addressFormGroup: FormGroup = this.form.get(["address", formControlName]) as FormGroup;
            array.forEach((value: string, index: number) => {
                const addressFormArray: FormArray = this.form.get(["address", formControlName]) as FormArray;
                addressFormArray.push(new FormControl());
                config.address.nameStreetConfig[index] = this.getFieldConfigAdd(addressFormGroup, index.toString());
                this.patchValueIfExist(value, ["address", formControlName, index.toString()]);
            });
        }
        else {
            const addressFormGroup: FormGroup = this.form.get(["address", formControlName]) as FormGroup;
            const addressFormArray: FormArray = this.form.get(["address", formControlName]) as FormArray;
            addressFormArray.push(new FormControl());
            config.address.nameStreetConfig[0] = this.getFieldConfigAdd(addressFormGroup, "0");
            this.patchValueIfExist(null, ["address", formControlName, "0"]);
        }
    }

    public getFieldConfigAdd(formGroup: FormGroup,formControlName: string, required: boolean = false): IFieldSpecs {
        return {
            formGroup,
            formControlName: formControlName,
            className: "watabiLightInput",
            label: formControlName === "0" ? this.wording.nameStreet : this.wording.complementAdd + formControlName,
            validators: (required ? [new Required()] : []),
            withAsteriskIfRequired: true,
        };
    }

    public addComplement(array: string[], formControlName: string, config: any, id: number) {
        const addressFormGroup: FormGroup = this.form.get(["address", formControlName]) as FormGroup;
        const addressFormArray: FormArray = this.form.get(["address", formControlName]) as FormArray;
        addressFormArray.push(new FormControl());
        config.address.nameStreetConfig[id] = this.getFieldConfigAdd(addressFormGroup, id.toString());
        this.patchValueIfExist(null, ["address", formControlName, id.toString()]);
    }

    public checkEmail(email: string): boolean {
        const filter: RegExp = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
        if (!filter.test(email)) {
            this.handleError(this.wording.invalidmail);
        }
        else {
            this.handleError();
        }
        return filter.test(email);
    }

    public getFirstOrNull(phoneArray: any, key: string): string {
        if (phoneArray && phoneArray.length) {
            return phoneArray[0][key];
        }
        return null;
    }

    public handleError(message: string = null): void {
        if (message) {
            this.errorNotification = {
                active: true,
                message
            };
        }
        else {
            this.errorNotification = {
                active: false,
                message: "",
            };
        }
    }

    private addValueToString(ori: string, val: string, last: string = ", "): string {
        if (val) {
            return ori + val + last;
        }
        return ori;
    }
}
